import { isEmpty, isFunction, isString } from "lodash"
import systemAlert from "./systemAlert"
import store from "../store"
import { newWindow } from "./browser"
const getUserGuide = (name) => {
  const target = USER_GUIDE_LIST.find(g => g.name === name)
  return target
}

const USER_GUIDE_URL = 'https://obvious-birthday-d04.notion.site/wecake-4740578d23ed45d298eaeda6b9eec3f9'

const defaultButton = [
  {
    color: 'text',
    label: '자세히 보기',
    onClick: () => {
      newWindow(USER_GUIDE_URL)
    }
  },
  {
    label: '확인'
  }
];

const USER_GUIDE_LIST = [
  {
    name: 'WELCOME',
    text: ({ employee }) => `${employee.name}님, 안녕하세요. 
    쉽고 편리한 스마트 서비스 wecake에 오신 것을 환영합니다!
    자세한 사용법과 기능은 여기(이용자 가이드 링크) 를 참조해 주세요!`,
    buttons: [...defaultButton]
  },
  {
    name: 'MOBILE_ACCESS',
    text: `모바일 접속 : wecake는 현재, PC Chrom 브라우저에 최적화되어 있어요. 
    빠른 시간 내에 모바일 지원이 가능하도록 노력하겠습니다. 
    wecake 앱 또는 PC에서 더욱 편리하게 이용해 주세요.`,
    buttons: [...defaultButton]
  },
  {
    name: 'ENCOURAGE_SIGNUP',
    text: ({ user }) => `${user.name}님, wecake를 꾸준히 사용하고 계시는군요!
    위케이크 파트너 세무사에게 ‘경리지원’ 또는 ‘기장대리’ 서비스를 이용하고 계시다면 
    wecake 솔루션의 모든 기능을 무료로 사용할 수 있어요! 
    구성원별 권한 관리 및 휴가, 자금, 전자계산서 등 더 많은 기능을 사용해 보세요!`,
    buttons: [...defaultButton]
  },
  {
    name: 'TASK_REGISTRATION',
    text: `우측 하단 [할일] 을 통해 언제, 어디서든 ‘할일’을 등록하세요!`,
    buttons: [...defaultButton]
  },
  {
    name: 'APPROVAL_REJECTION',
    text: `대기 중인 할일이 있습니다. 
    해당 할일을 확인하고 [승인하기], [반려하기]를 이용하여 할일을 진행하세요!`,
    buttons: [...defaultButton]
  },
  {
    name: 'COMMUTE_RECORDING',
    text: `[홈] 메뉴 또는 앱을 통해 출퇴근 시간을 기록하세요!`,
    buttons: [...defaultButton]
  },
  {
    name: 'COMMUTE_RECORD',
    text: `[나의 근로시간]을 통해 근무시간을 확인할 수 있어요!
    출퇴근 기록 수정이 필요한 경우, 우측 하단 [할일]의 [출퇴근 시간 정정 신청]을 진행하세요!`,
    buttons: [...defaultButton]
  },
  {
    name: 'COMMUTE_MANAGEMENT',
    text: `구성원의 출퇴근 시간을 확인하세요.`,
    buttons: [...defaultButton]
  },
  {
    name: 'WORKING_TIME_MANAGEMENT',
    text: '구성원의 근로시간(일반, 야간, 휴일)을 하세요!',
    buttons: [...defaultButton]
  },
  {
    name: 'DEPARTMENT_WORK_STATUS',
    text: '지각, 조퇴, 결근, 근무시간 미달 등 근무 현황을 확인하세요!',
    buttons: [...defaultButton]
  },
  {
    name: 'COMMUTE_LOCATION_MANAGEMENT',
    text: '출퇴근 장소를 등록하세요. 지정 장소의 출퇴근 허용 반경을 사용할 수 있습니다.',
    buttons: [...defaultButton]
  },
  {
    name: 'WORK_SCHEDULE_MANAGEMENT',
    text: '개인별, 부서별 출퇴근 기록과 근무 시간과 근무 요일 등을 설정하세요. [출퇴근 장소]와 함께 사용할 수 있습니다!',
    buttons: [...defaultButton]
  },
  {
    name: 'PUBLIC_HOLIDAY',
    text: '회사 기념일, 공통 휴일을 추가하세요!',
    buttons: [...defaultButton]
  },
  {
    name: 'OTHER_WORK_ITEMS',
    text: '출장, 파견 등으로 인해 구성원이 출퇴근을 할 수 없을 때 근무시간 인정이 가능해요. [기타근무항목]을 추가해 보세요!',
    buttons: [...defaultButton]
  },
  {
    name: 'ORGANIZATION_CHART',
    text: ({ company }) => `[사람] 메뉴를 통해 조직도를 구성하고 [회사 초대 URL 복사] 를 이용하여 구성원을 ${company.name}로 초대하세요!`,
    buttons: [...defaultButton]
  },
  {
    name: 'COMPANY_INFO',
    text: '우리 회사의 정보를 관리하세요!',
    buttons: [...defaultButton]
  },
]


const userGuide = (guide) => {
  if (!guide) return
  let guideTarget;
  const profile = store.getState().Profile
  if (isEmpty(profile)) return
  if (isString(guide)) {
    guideTarget = getUserGuide(guide)
  } else {
    guideTarget = guide
  }
  if (guideTarget) {
    const { text, ..._guide } = guideTarget
    systemAlert(
      isFunction(text) ? text(profile) : text,
      {
        ..._guide
      }
    )
  }
}


export {
  userGuide,
  USER_GUIDE_URL
}
